import { baseTheme } from '@codezo/theme';
import { mergeThemeOverrides } from '@mantine/core';

export const theme = mergeThemeOverrides(baseTheme);
